export const testimonials = [
  {
    stars: 5,
    text: 'NIVORA transformed our vision into a home that perfectly reflects our family\'s lifestyle. The balance of warm wooden finishes, elegant detailing, and functional planning exceeded every expectation. Their professionalism, transparency, and craftsmanship made the entire journey enjoyable. Every guest who visits appreciates the timeless beauty of our home.',
    name: 'Arvind Mohite',
    location: 'Pune',
    project: 'RESIDENTIAL — 4BHK RESIDENCE',
    initials: 'AM',
  },
  {
    stars: 5,
    text: 'From the very first design discussion to the final handover, the NIVORA team understood exactly what we wanted. They created a home that is modern, practical, and incredibly welcoming. Their attention to detail and execution quality are simply outstanding.',
    name: 'Tushar Shah',
    location: 'Pune',
    project: 'RESIDENTIAL — 4BHK RESIDENCE',
    initials: 'TS',
  },
  {
    stars: 5,
    text: 'Designing a bungalow requires thoughtful planning, and NIVORA delivered beyond our expectations. Every room flows beautifully into the next, with a perfect blend of luxury and functionality. The quality of materials and finishing reflects true craftsmanship.',
    name: 'Mayur Patil',
    location: 'Mumbai',
    project: 'RESIDENTIAL — BUNGALOW',
    initials: 'MP',
  },
  {
    stars: 5,
    text: 'Our office now represents our brand perfectly. The layout has improved productivity, while the elegant interiors leave a lasting impression on every client who visits. NIVORA managed the entire project professionally and delivered exactly as promised.',
    name: 'Parag Bari',
    location: 'Mumbai',
    project: 'COMMERCIAL — OFFICE',
    initials: 'PB',
  },
  {
    stars: 5,
    text: 'We wanted a peaceful home that felt warm and timeless, and NIVORA achieved exactly that. The soft curves, lighting, and neutral palette create a calming atmosphere that our family enjoys every day. It truly feels like home.',
    name: 'Tarun Raisinghania',
    location: 'Mumbai',
    project: 'RESIDENTIAL — APARTMENT',
    initials: 'TR',
  },
  {
    stars: 5,
    text: 'NIVORA has an incredible ability to create elegance through simplicity. Every texture, finish, and lighting detail has been carefully planned. The final result is sophisticated, functional, and far more beautiful than we imagined.',
    name: 'Samiksha Shetty',
    location: 'Mumbai',
    project: 'RESIDENTIAL — APARTMENT',
    initials: 'SS',
  },
  {
    stars: 5,
    text: 'The team designed every space with precision and purpose. The duplex feels spacious, luxurious, and incredibly comfortable. Their communication, project management, and commitment to quality made the entire experience completely stress-free.',
    name: 'Kapil Arora',
    location: 'Pune',
    project: 'RESIDENTIAL — DUPLEX',
    initials: 'KA',
  },
  {
    stars: 5,
    text: 'NIVORA beautifully balanced warmth, luxury, and functionality in our home. The custom furniture, lighting, and thoughtful detailing have completely transformed our everyday living experience. We highly recommend NIVORA to anyone looking for premium interiors.',
    name: 'Rahul Patil',
    location: 'Mumbai',
    project: 'RESIDENTIAL — APARTMENT',
    initials: 'RP',
  },
  {
    stars: 5,
    text: 'Nivora took my vision and refined it into something I never thought possible. Their material selection is impeccable.',
    name: 'Aditi R.',
    location: 'Mumbai',
    project: 'RESIDENTIAL — HOME INTERIOR',
    initials: 'AR',
  },
]